import {useMutation, useQueryClient} from '@github-ui/react-query'
import {fetchCAPI} from '../utils/fetch-capi'

export const PLAN_STATE_APPROVED = 'approved'
export const PLAN_STATE_DISMISSED = 'dismissed'
export type PlanState = typeof PLAN_STATE_APPROVED | typeof PLAN_STATE_DISMISSED

export const PLAN_EVENT_APPROVED = 'plan_approved'
export const PLAN_EVENT_DISMISSED = 'plan_dismissed'

export const PLAN_STATE_TO_EVENT: Record<PlanState, string> = {
  [PLAN_STATE_APPROVED]: PLAN_EVENT_APPROVED,
  [PLAN_STATE_DISMISSED]: PLAN_EVENT_DISMISSED,
}

interface SessionPatch {
  user_id: number
  session_id: string
  task_id?: string
  event_identifiers?: string[]
}

interface PatchSessionResponse {
  success_count: number
  failure_count: number
  failures: Array<{session_id: string; error: string; error_type: string}>
}

interface UsePatchSessionOptions {
  onSuccess?: (data: PatchSessionResponse, variables: SessionPatch) => void
  onError?: (error: Error, variables: SessionPatch) => void
}

export function usePatchSession({onSuccess, onError}: UsePatchSessionOptions = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['patchSession'],
    mutationFn: async (patch: SessionPatch): Promise<PatchSessionResponse> => {
      const response = await fetchCAPI({
        path: '/agents/sessions',
        method: 'PATCH',
        body: {
          patches: [patch],
        },
      })
      const data = (await response.json()) as PatchSessionResponse
      if (data.failure_count > 0) {
        throw new Error(data.failures[0]?.error ?? 'Failed to patch session')
      }
      return data
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({queryKey: ['agent-sessions']})
      onSuccess?.(data, variables)
    },
    onError: (error: Error, variables) => {
      onError?.(error, variables)
    },
  })
}
